module.exports = __webpack_public_path__ + "img/user.1a70cb73.svg";